export default {
  dailyTasks: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  professional: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  clients: {
    loading: false,
    lastUpdate: null,
    data: [],
    selected: [],
  },
  import: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  export: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  showModalAssign: false,
  idModalAssign: null,
  modalInfoAlert: null,
  // {{NEXT}}
}
